import { isArray, isNil } from 'lodash';
import { PROJECTS_TAG } from '../../../../data/actions';

export const DATA_EXTRACTION_SET_SESSIONS = 'DATA_EXTRACTION_SET_SESSIONS';

export const SESSIONS_TAG = 'Sessions';

export const setProjectSessions = sessions => {
  return {
    type: DATA_EXTRACTION_SET_SESSIONS,
    sessions
  };
};

/**
 * Get the sessions of project form api
 * @param projectId
 * @returns {function(*, *, {apiClient: *}): boolean}
 */
export const getProjectSessions = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    const sessions = await apiClient.call(PROJECTS_TAG, 'getProjectSessions', {
      projectId,
      $limit: 1000
    });

    dispatch(setProjectSessions(sessions.data));
    return true;
  };
};

/**
 * Add a new empty session
 * @returns {Function}
 */
export const addNewSession = projectId => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(
      SESSIONS_TAG,
      'createSession',
      {},
      {
        project_id: projectId
      }
    );
    dispatch(getProjectSessions(projectId));
  };
};

/**
 * Start session
 * @param sessionP
 * @param callback
 * @returns {Function}
 */
export const startSession = (sessionP, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    delete sessionP.participations; // eslint-disable-line no-param-reassign
    delete sessionP.files; // eslint-disable-line no-param-reassign

    let response = {};

    try {
      const session = await apiClient.call(
        SESSIONS_TAG,
        'updateSession',
        {
          id: sessionP.id
        },
        sessionP
      );

      if (!isNil(session) && isArray(session.data) && !isNil(session.data[0])) {
        [response] = session.data;
      }
    } catch (e) {
      console.log('updateSession error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    dispatch(getProjectSessions(getState().projects.single.active.id));

    callback && callback(response);
  };
};

/**
 * Update log session
 * @param sessionP
 * @returns {Function}
 */
export const updateLogSession = sessionP => {
  return async (dispatch, getState, { apiClient }) => {
    delete sessionP.participations; // eslint-disable-line no-param-reassign
    delete sessionP.files; // eslint-disable-line no-param-reassign

    try {
      await apiClient.call(
        SESSIONS_TAG,
        'updateSession',
        {
          id: sessionP.id
        },
        sessionP
      );
    } catch (e) {
      console.log('updateLogSession error'); // eslint-disable-line no-console
      console.log(e); // eslint-disable-line no-console
    }

    dispatch(getProjectSessions(getState().projects.single.active.id));
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/sessionsActions.js